import { Routes } from '@angular/router';

import { ApplicationGuard } from './core/guards/application.auth.guard';
import { DowntimeBannerGuard } from './core/guards/downtime-banner.guard';
import { BackofficeGuard } from './core/guards/backoffice.guard';
import { DefaultRouteGuard } from './core/guards/default-route.guard';
import { TranslationLoaderGuard } from './core/guards/translation-loader.guard';
import { ValidPages } from './shared/enums/valid-pages.enum';

export const routes: Routes = [
  {
    path: 'dashboard',
    canActivate: [TranslationLoaderGuard, ApplicationGuard],
    data: { page: ValidPages.APPLICATION },
    loadChildren: () => import('./pages/dashboard.routes').then((m) => m.routes),
  },
  {
    path: 'backoffice',
    canMatch: [BackofficeGuard],
    canActivate: [TranslationLoaderGuard, ApplicationGuard],
    data: { page: ValidPages.BACKOFFICE },
    loadChildren: () => import('./pages/backoffice/backoffice.routes').then((m) => m.routes),
  },
  {
    path: 'stepper',
    canActivate: [TranslationLoaderGuard, ApplicationGuard, DowntimeBannerGuard],
    data: { page: ValidPages.APPLICATION },
    loadChildren: () => import('./pages/stepper/stepper.routes').then((m) => m.routes),
  },
  {
    path: 'unauthorized',
    canActivate: [TranslationLoaderGuard],
    loadChildren: () => import('./pages/unauthorized/unauthorized.routes').then((m) => m.routes),
  },
  // BatteryCare - Route for BatteryCare application
  {
    path: 'batterycare/dashboard',
    canActivate: [TranslationLoaderGuard, ApplicationGuard],
    data: { page: ValidPages.BATTERY_CARE },
    loadChildren: () => import('./pages/battery-care/battery-care.routes').then((m) => m.routes),
  },
  // BatteryCare - Wildcard route using DefaultRouteGuard to redirect the user to the appropriate "home" page based on his roles
  {
    path: '**',
    canActivate: [DefaultRouteGuard],
    children: [],
  },
];
